import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import ReadingPanePosition from 'owa-session-store/lib/store/schema/ReadingPanePosition';
export default function isReadingPanePositionRight() {
    return (getUserConfiguration().UserOptions.GlobalReadingPanePositionReact ==
        ReadingPanePosition.Right);
}
//# sourceMappingURL=isReadingPanePositionRight.js.map